module.exports = __webpack_public_path__ + "img/video.39c18fcd.png";